import React from "react"

export default function Chair() {
  return (
    <symbol id="svg-select-chair" viewBox="0 0 32 32">
      <path
        fill="currentColor"
        d="M30.1,18.4l-5.1-5c-0.4-0.4-0.9-0.6-1.5-0.6H12.9l-7-6.9c-0.8-0.8-2.2-0.8-3,0C2.5,6.3,2.3,6.8,2.3,7.4s0.2,1.1,0.6,1.5   l7.6,7.5c0.4,0.4,0.9,0.6,1.5,0.6h10.6l4.4,4.4c0.4,0.4,1,0.6,1.5,0.6s1.1-0.2,1.5-0.6s0.6-0.9,0.6-1.5   C30.8,19.3,30.5,18.8,30.1,18.4z M29.2,20.4c-0.3,0.3-0.8,0.3-1,0l-4.9-4.8H12.1c-0.2,0-0.4-0.1-0.5-0.2L4,7.9l0,0   C3.9,7.8,3.8,7.6,3.8,7.4S3.9,7,4,6.9c0.1-0.1,0.3-0.2,0.5-0.2S4.9,6.8,5,6.9l7.4,7.3h11.2c0.2,0,0.4,0.1,0.5,0.2l5.1,5   c0.1,0.1,0.2,0.3,0.2,0.5S29.3,20.3,29.2,20.4z"
      />
      <path
        fill="currentColor"
        d="M21,24.2c-1.1-0.2-1.7-0.3-1.7-1.6c0-0.8,1.4-2.2,3.2-2.5l-0.1-1.4h-9.5l-0.1,1.4c1.9,0.3,3.2,1.7,3.2,2.5   c0,1.2-0.5,1.4-1.7,1.6c-0.8,0.1-2.2,0.4-2.2,1.9v0.7H23v-0.7C23.2,24.6,21.8,24.3,21,24.2z M15.5,25.4c1-0.3,2-0.9,2-2.8   c0-0.9-0.6-1.8-1.4-2.5h3.3c-0.9,0.7-1.4,1.6-1.4,2.5c0,1.9,1.1,2.5,2,2.8H15.5z"
      />
    </symbol>
  )
}
